import { render, staticRenderFns } from "./AddNewSectorModal.vue?vue&type=template&id=39c45533&"
import script from "./AddNewSectorModal.vue?vue&type=script&lang=js&"
export * from "./AddNewSectorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSectorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports